/**
 * 在县城规划区范围内购房包干费用=包干货币化安置费用cuComp元+包干奖励补助cuBonus元（含拆迁奖励及过渡费）
 * 县城规划区
 *   包干货币化安置费用 →  cuComp
 *   包干奖励补助       →  cuBonus
 *
 * 在乡镇购房包干费用=包干货币化安置费用rtComp元+包干奖励补助rtBonus元（含拆迁奖励及过渡费）
 * 乡镇
 *   包干货币化安置费用 →  rtComp
 *   包干奖励补助       →  rtBonus
 */
export enum CURRENCY_TOWN_DATA_INDEX {
  CU_COMP = 'huoBiHuaAnZhiBaoGanXianCheng',
  CU_BONUS = 'huoBiHuaAnZhiJiangLiXianCheng',
  RT_COMP = 'huoBiHuaAnZhiBaoGanXiangZhen',
  RT_BONUS = 'huoBiHuaAnZhiJiangLiXiangZhen'
}
